module.exports = __webpack_public_path__ + "static/img/__7901.bb67aaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__7901.jpg
// module id = lm81
// module chunks = 0